import React, { useState } from "react";
import ModalContainer from "../common/ModalContainer";
import { formatMoney } from "../../features/utils/formatMoney";
import { useDispatch, useSelector } from "react-redux";
import { setInsuranceOrders } from "../../redux/reducers/orderSlice";
import CommonFlexMarkup from "../common/CommonFlexMarkup";
import { useInsuranceApi } from "../../hooks/useInsuranceApi";

export const UpdateFareInsuranceBookingModal = ({
  setOpen,
  open,
  booking,
  page,
}) => {
  const [fare, setFare] = useState(booking?.fareTotal || booking?.grandTotal);
  const dispatch = useDispatch();
  const { insuranceOrders } = useSelector((state) => state.order);
  const { updateFarePrice } = useInsuranceApi();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    await updateFarePrice({
      fare,
      booking,
      setLoading,
      callbackUrl: (data) => {
        if (page) {
          localStorage.setItem(
            `booking/${data?._id || booking?.bookingId}`,
            JSON.stringify(data)
          );
        } else {
          dispatch(
            setInsuranceOrders(
              insuranceOrders?.map((item) =>
                item?._id === data?._id ? data : item
              )
            )
          );
        }
        setOpen(false);
      },
    });
  };

  if (open) {
    console.log({ booking });
  }

  return (
    <>
      <ModalContainer
        open={open}
        setOpen={setOpen}
        secondary
        padding="px-4 py-6"
        title="Update Fare"
        subTitle="Enter the fare amount you want to add"
      >
        <div className="w-full flex flex-col">
          <div className="w-full">
            <div className="relative overflow-x-auto flex flex-col scroll-hide">
              <div className="flex flex-col bg-[#F0F6FC] p-4 w-full rounded-md">
                <CommonFlexMarkup
                  amount={booking?.fareTotal || booking?.grandTotal}
                  callback={({ total }) => {
                    setFare(total);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="border-[#EFECEC] border-t"></div>
          <hr className="border-gray-300 my-3 mt-6" />
          <div className="flex justify-between items-center gap-5 ">
            <div className="flex gap-2 text-md text-gray-400">
              <span>Original price :</span>
              <span className="font-bold">
                {formatMoney(booking.grandTotal)}
              </span>
            </div>
            <div className="flex gap-2 text-lg md:text-2xl">
              <span>New fare price</span>
              <span className="font-bold">{formatMoney(fare)}</span>
            </div>
          </div>
          <hr className="border-gray-300 my-3 mb-6" />
          <div className="flex gap-6 items-center">
            <button
              onClick={() => setOpen(false)}
              className={ClassName.whiteButton}
            >
              Cancel
            </button>
            <button
              className="bg-primary1 flex items-center justify-center text-secondaryflex-1 text-white w-full py-4 rounded-lg text-xs sm:text-lg"
              onClick={() => handleConfirm()}
            >
              {loading ? (
                <div className="buttonLoader"></div>
              ) : (
                <span>Confirm</span>
              )}
            </button>
          </div>
        </div>
      </ModalContainer>
    </>
  );
};

const ClassName = {
  whiteButton: "py-4 px-6 text-xs md:text-lg font-bold w-full max-w-[174px]",
};
